import styles from "./PrimaryButton.module.scss"

interface Props extends React.PropsWithChildren {
  className?: string
  onClick: () => void
}

const PrimaryButton = (props: Props) => {
  return (
    <button className={`${styles.button} ${props.className ?? ""}`} onClick={props.onClick}>
      {props.children}
    </button>
  )
}

export default PrimaryButton
